/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { CSMasterBusinessService } from '../../resources/color-selection-master-finder-business.service';
import { CSMasterFinderDialogComponent } from './color-selection-master-finder-dialog.component';

export const colorSelectionMasterFinderDialogRoute = createDialogRoute({
  component: CSMasterFinderDialogComponent,
  init: CSMasterBusinessService,
});
